/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 09:27:30
 */
import { unwrapResult } from "@reduxjs/toolkit"
import {
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Tag,
} from "antd"
import moment from "moment"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { ThemeContext } from "../../../theme/ThemeContext"
import { DateTimeFormatSimple } from "../../../models/datetime"
import { InfoCircleOutlined } from "@ant-design/icons"
import { GenderOptions, getGenderName } from "../../../models/user"
import ZgzsbhIcon from "../assets/doctor/zgzsbh.jpg"
import ZyjbIcon from "../assets/doctor/zyjb.jpg"
import ZylbIcon from "../assets/doctor/zylb.jpg"
import ZyfwIcon from "../assets/doctor/zyfw.jpg"
import FzrqIcon from "../assets/doctor/fzrq.jpg"
import RzzgIcon from "../assets/doctor/rzzg.jpg"
import ZyfzrqIcon from "../assets/doctor/zyfzrq.jpg"
import {
  getDoctorsInDepartment,
  selectDoctors,
} from "../../registration/register/registerSlice"

interface ReportModalProps {
  visible: boolean
  reportLoading: boolean
  data: any
  onCancel: () => void
  onOk: (data: any) => void
}

export const ReportDoctorModal = ({
  visible,
  reportLoading,
  data,
  onCancel,
  onOk,
}: ReportModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const { CheckableTag } = Tag

  const { Option } = Select

  const doctors = useSelector(selectDoctors)

  const { TextArea } = Input

  const theme = useContext(ThemeContext)

  const [isVisible, setIsVisible] = useState(false)

  const [keyword, setKeyword] = useState("")

  const [idCardRules, setIdCardRules] = useState<any[]>([
    {
      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: "身份证格式错误",
    },
    {
      max: 18,
      message: "最长18位!",
    },
    {
      required: true,
    },
  ])

  const doctorNameOverlay = (
    <Menu style={{ maxHeight: 400, overflow: "auto" }}>
      {doctors
        ?.filter((n) => n?.stationCategory == 1 && n?.state == 1)
        ?.map((p: any, i: number) => (
          <Menu.Item
            key={i}
            onClick={() => {
              setIsVisible(false)
              setKeyword(p?.name)
              form.setFieldsValue({
                name: p.name,
                sex: p.sex,
                identityCard: p.identityCard,
                practice: p.practiceCertificate,
                qualification: p.qualificationCertificate,
              })
            }}
          >
            <Space>
              <span>{p.name}</span>
            </Space>
          </Menu.Item>
        ))}
    </Menu>
  )


  useEffect(() => {
    if (visible) {
      dispatch(getDoctorsInDepartment(""))
      if (data) {
        form.setFieldsValue({
          ...data,
          licenceDate: data?.licenceDate ? moment(data?.licenceDate) : "",
          qualificationDate: data?.qualificationDate
            ? moment(data?.qualificationDate)
            : "",
          birthday: data?.birthday ? moment(data?.birthday) : "",
        })
        setKeyword(data?.name)
      }
    } else {
      form.resetFields()
      setKeyword('')
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      title="上报医护人员"
      width={1000}
      cancelText="取消"
      okText="确认提交"
      confirmLoading={reportLoading}
      onCancel={onCancel}
      onOk={form.submit}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        autoComplete="off"
        initialValues={{
          type: 1,
          physicianType: 1,
        }}
        onFinish={(values) => {
          const dataValues = {
            ...values,
            workState: data?.workState,
            licenceDate: values.licenceDate
              ? moment(values.licenceDate).format(DateTimeFormatSimple)
              : null,
            qualificationDate: values.qualificationDate
              ? moment(values.qualificationDate).format(DateTimeFormatSimple)
              : null,
            birthday: values.birthday
              ? moment(values.birthday).format(DateTimeFormatSimple)
              : null,
          }
          const processedValues = Object.fromEntries(
            Object.entries(dataValues).map(([key, value]) => [
              key,
              value === "" ? null : value, // 转换逻辑
            ])
          )
          onOk(processedValues)
        }}
      >
        <Row>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="人员类型" name="type">
                  <Radio.Group>
                    <Radio value={1} disabled>
                      医生
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}></Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="医生姓名"
                  name="name"
                  rules={[{ required: true }]}
                >
                  <Dropdown overlay={doctorNameOverlay} visible={isVisible}>
                    <Input
                      allowClear
                      placeholder="请输入"
                      value={keyword}
                      onFocus={() => {
                        setIsVisible(true)
                      }}
                      onBlur={() => {
                        setTimeout(() => {
                          setIsVisible(false)
                        }, 300)
                      }}
                      onClick={() => {
                        setIsVisible(true)
                      }}
                      onChange={(e) => {
                        setIsVisible(true)
                        setKeyword(e.target.value)
                        form.setFieldsValue({ name: e.target.value })
                      }}
                    />
                  </Dropdown>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="医生类型" name="physicianType">
                  <Radio.Group>
                    <Radio value={1}> 主执业 </Radio>
                    <Radio value={2}> 多点执业 </Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="性别" name="sex" rules={[{ required: true }]}>
                  <Select placeholder="请选择" allowClear>
                    {GenderOptions.map((g) => (
                      <Option key={g} value={g}>
                        {getGenderName(g)}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="出生年月" name="birthday">
                  <DatePicker
                    style={{ width: "100%" }}
                    format={DateTimeFormatSimple}
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="民族" name="nation">
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="身份证号码"
                  name="identityCard"
                  rules={idCardRules}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="学历" name="education">
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>小学</Option>
                    <Option value={1}>初中</Option>
                    <Option value={2}>高中</Option>
                    <Option value={3}>专科</Option>
                    <Option value={4}>本科</Option>
                    <Option value={5}>硕士研究生</Option>
                    <Option value={6}>博士研究生</Option>
                    <Option value={7}>传统医学师承和确有专长</Option>
                    <Option value={8}>无学历</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="毕业学校" name="graduationSchool">
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="资格证书编号"
                  name="qualification"
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={ZgzsbhIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="执业证书编号"
                  name="practice"
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="执业级别"
                  name="practiceLevel"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>执业医师</Option>
                    <Option value={1}>执业助理医师</Option>
                    <Option value={2}>乡镇执业助理医师</Option>
                    <Option value={3}>执业助理医师(师承)</Option>
                    <Option value={4}>执业医师(师承)</Option>
                    <Option value={5}>乡村全科执业助理医师</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={ZyjbIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="执业类别"
                  name="practiceCategory"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>临床</Option>
                    <Option value={1}>口腔</Option>
                    <Option value={2}>中医</Option>
                    <Option value={3}>中西医结合</Option>
                    <Option value={4}>公共卫生</Option>
                    <Option value={5}>临床和中医</Option>
                    <Option value={6}>壮医</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={ZylbIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="执业范围"
                  name="practiceArea"
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={ZyfwIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="任职资格"
                  name="appoint"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={1}>医师</Option>
                    <Option value={2}>医士</Option>
                    <Option value={3}>主治医师</Option>
                    <Option value={4}>副主任医师</Option>
                    <Option value={5}>主任医师</Option>
                    <Option value={7}>其它</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={RzzgIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="抗菌权限"
                  name="antibacterialDrugPermission"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>无权限</Option>
                    <Option value={1}>非限制级</Option>
                    <Option value={2}>限制级</Option>
                    <Option value={3}>特殊级</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      <p>
                        抗菌权限：医生的抗菌药物处方权限实行分级管理，依据《抗菌药物临床应用管理办法》（卫生部令第84号）及相关政策，不同职称和培训资质的医生拥有不同的抗菌药物处方权限。
                      </p>
                      <p>
                        初级职称医师（住院医师、助理医师）：可开具非限制使用级抗菌药物
                      </p>
                      <p>
                        中级职称医师（主治医师）：可开具非限制级 +
                        限制级抗菌药物。
                      </p>
                      <p>
                        高级职称医师（副主任医师及以上）：可开具所有级别抗菌药物。
                      </p>
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item
                  label="精麻权限"
                  name="anestheticDrugPermission"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="请选择" allowClear>
                    <Option value={0}>无权限</Option>
                    <Option value={1}>有权限</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <div style={{ width: "300px" }}>
                      <p>
                        精麻权限：是指第一类精神药品和麻醉药品的权限，需医院专项培训考核，并报卫健委备案
                      </p>
                      <p>第二类精神药品权限：所有医生均可开</p>
                      <p>
                        第一类精神药品权限：需医院专项培训考核，并报卫健委备案
                      </p>
                      <p>麻醉药品权限：需医院专项培训考核，并报卫健委备案</p>
                      <p>
                        第一类精神药品和麻醉药品权限：需医院专项培训考核，并报卫健委备案
                      </p>
                    </div>
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="发证机关" name="licenceOrgan">
                  <Input allowClear placeholder="请输入" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="执业发证日期" name="licenceDate">
                  <DatePicker
                    style={{ width: "100%" }}
                    format={DateTimeFormatSimple}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={ZyfzrqIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={22}>
                <Form.Item label="资格发证日期" name="qualificationDate">
                  <DatePicker
                    style={{ width: "100%" }}
                    format={DateTimeFormatSimple}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "6px 0 0 10px" }}>
                <Popover
                  content={
                    <img src={FzrqIcon} alt="" style={{ width: "400px" }} />
                  }
                  placement="right"
                  title="说明"
                >
                  <InfoCircleOutlined
                    style={{ color: "#5896FF", fontSize: "16px" }}
                  />
                </Popover>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
